import { updateTenderLeadFollowUp } from '@data'
import FollowUpRemarks from '@pages/Admin/Tenderbook/components/FollowUpRemarks'

const LeadRemarks = ({ data, update }) => (
	<FollowUpRemarks data={data} update={update} save={(payload) => updateTenderLeadFollowUp(payload, data?.lead_id)} />
)

export default LeadRemarks
